import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Redux
import { userSelector } from 'Redux/LoggedUserSlice';

// Constants
import { EMPLOYEE_ROLE_ID } from 'Constants/General';

// Hooks
import useTranslation from 'Hooks/useTranslation';

// Components
import { EvaluationContainer, LoadingContainer } from './style';
import EvaluationCard from './Components/EvaluationCard';
import useEvaluationsTab from './Hooks/useEvaluationsTab';

export default function Evaluations({ course }) {
  // Diccionario
  const { t2 } = useTranslation('CourseDetails');

  // Course ID
  const courseId = course?.id;

  // Obtenemos el ROL del usuario
  const { roleId, id } = useSelector(userSelector);

  // Obtenemos el historial de navegación
  const history = useHistory();

  // Obtenemos las evaluaciones del usuario de este curso
  const { userEvaluations } = useEvaluationsTab({ courseId, userId: id });
  // TODO: Refactorizar para obtener más datos de las evaluaciones

  // Si no hay evaluaciones, mostramos un mensaje de carga
  if (userEvaluations?.length === 0) {
    return <LoadingContainer>{t2('NoEvaluations')}</LoadingContainer>;
  }

  return (
    <EvaluationContainer>
      {userEvaluations &&
        userEvaluations.map((userEvaluation, index) => {
          return (
            <EvaluationCard
              key={userEvaluation.userEvaluationId || index.toString()}
              isEmployee={roleId === EMPLOYEE_ROLE_ID}
              userEvaluation={userEvaluation}
              courseId={courseId}
              courseName={course?.name}
              onClick={
                roleId === EMPLOYEE_ROLE_ID
                  ? null
                  : () => history.push(`/cursos/${courseId}/lecciones/${userEvaluation.lessonId}`)
              }
            />
          );
        })}
    </EvaluationContainer>
  );
}
